import { Component } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useStateValue } from "../Stateprovider";
import { useHistory } from "react-router-dom";
import { auth } from "../firebase";
import "../css/Header.css";

import React from "react";

function HeaderAll() {
  const [{ basket, user }, dispatch] = useStateValue();
  const history = useHistory();

  const handleAuth = (e) => {
    e.preventDefault();
    if (user) {
      auth
        .signOut()
        .then(function () {
          // Sign-out successful.
          history.push("/");
        })
        .catch(function (error) {
          // An error happened.
          console.log(error);
        });
    } else {
      history.push("/login");
    }
  };

  return (
    <>
      <Navbar className="bgcol" variant="light" sticky="top" expand="lg">
        <Link to="/">
          <Navbar.Brand>Protude</Navbar.Brand>
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            {user ? (
              <Link className="header__link pr-3" to="/storefront">
                StoreFront
              </Link>
            ) : (
              <Link></Link>
            )}
            {user ? (
              <Link className="header__link pr-3" to="/myprojects">
                My Projects
              </Link>
            ) : (
              <Link></Link>
            )}
            {user ? (
              <Link className="header__link pr-3" to="/cart">
                Cart {basket?.length}
              </Link>
            ) : (
              <Link></Link>
            )}
            <Link className="header__link pr-3" onClick={handleAuth}>
              {user ? "Logout" : "Login"}
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
}

export default HeaderAll;
